import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const PLP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-plp-enclosure',
  ENCLOSURE: 'invites-plp-enclosure',
  HOLIDAY: 'invites-plp-holiday',
  INVITATION: 'invites-plp-invitation',
  MENU: 'invites-plp-menu',
  PLACE: 'invites-plp-placecard',
  PROGRAM: 'invites-plp-program',
  SAVE_THE_DATE: 'invites-plp-savethedate',
  DIGITAL_SAVE_THE_DATE: 'invites-plp-digitalsavethedate',
  CHANGE_THE_DATE: 'invites-plp-changethedate',
  THANK_YOU: 'invites-plp-thankyou',
  MATCHING_SUITES: 'invites-plp-matching-suites',
  [CARD_TYPE_MAP.weddingShower]: 'invites-plp-wedding-shower',
  [CARD_TYPE_MAP.tableNumber]: 'invites-plp-table-number',
  [CARD_TYPE_MAP.paperAddOns]: 'invites-plp-paperaddons',
} as const;
